import React from "react";
import Flow01 from "./img/iep-userflow01.png";
import Flow02 from "./img/iep-userflow02.png";

function IEPCardCollab() {
	return (
		<section className="card-iep-collab">
			<div className="content-row">
				<article className="content">
					<h2 className="title">Leading UX and UI implementation</h2>
					<p>
						Working to a tight deadline for a v1 launch, a selection of
						developers were assigned to assist me in delivering the application
						interface.
					</p>
					<p>
						No-one on the team had experience with Angular, so we had to learn
						fast. I took over the build relating to the UI layout and
						interactivity (HTML, SCSS, some JS). I built components in a modular
						way so the app was flexible and dynamic.
					</p>
					<p>
						The developers focused on building an orchestration layer and
						implementing business logic in the many application forms. I pushed
						my work daily to a repo for devs to integrate with their local build
						environment.
					</p>
					<p>
						As they were offshore, I facilitated early-morning standups and
						regular product reviews and demos so all the team had visibility of
						progress.
					</p>
				</article>
				<div className="wire-group">
					<figure>
						<span className="wire">
							<img src={Flow01} alt="Wireframe for Eligibility application" />
						</span>
						<figcaption>
							Examples of UI/UX notes for developers; creating a Client and
							Carrier record validations and business logic
						</figcaption>
					</figure>
					<figure>
						<span className="wire">
							<img src={Flow02} alt="Wireframe for Eligibility application" />
						</span>
					</figure>
				</div>
			</div>
		</section>
	);
}

export default IEPCardCollab;
